module.exports = __webpack_public_path__ + "static/media/printer.3606f0b3.svg";